import MoreVertIcon from '@mui/icons-material/MoreVert'
import { Box, Divider, Menu, MenuItem, Typography, styled } from '@mui/material'
import { ReactComponent as IconChangePwd } from 'assets/icons/IconChangePwd.svg'
import { ReactComponent as IconLogout } from 'assets/icons/IconLogout.svg'
import { ReactComponent as IconSetting } from 'assets/icons/IconSetting.svg'
import { ReactComponent as IconStorage } from 'assets/icons/IconStorage.svg'
import { TooltipCC } from 'components/common'
import { PATH_ROOT } from 'constants/api'
// import { IconChangePassword, IconLogout, IconSetting, IconStorage } from 'components/common/IconCommon'
import { useMenuCC } from 'hooks'
import AvatarUser from 'pages/manager-users-SIP/components/AvatarUser'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { endSession as logout } from 'store/sessionSlice'
import theme, { color } from 'theme'
import { getUserProperty, setOpenDialogCC } from 'utils/helpers'
import { USER_PROPERTIES } from 'constants/user'
import { clearConfirmRefreshTimer } from 'services/sessionTimerService'

const MenuItemCC = styled(MenuItem)(({ theme }) => ({
    color: theme.palette.text.primary,
    fontWeight: 500,
    '&:hover': {
        backgroundColor: color.greyIL07,
        color: theme.palette.primary.main
    },
    '&:hover p': {
        color: theme.palette.primary.main
    },
    '&:hover > svg > path': {
        fill: theme.palette.primary.main
    }
}))

const MenuItemStorage = styled(MenuItem)(({ theme }) => ({
    color: color.default,
    fontWeight: 500,
    '&:hover': {
        backgroundColor: color.greyIL07,
        color: theme.palette.primary.main,
        '& svg path': {
            stroke: theme.palette.primary.main
        }
    },
    '&:hover p': {
        color: theme.palette.primary.main
    }
}))

const ProfileCC = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { open, anchorEl, setAnchorEl } = useMenuCC()
    const navigate = useNavigate()

    const userAvatar = getUserProperty(USER_PROPERTIES.AVATAR)
    const userBgrColor = getUserProperty(USER_PROPERTIES.BGRCOLOR)

    const handleLogout = async _ => {
        clearConfirmRefreshTimer()
        toast.dismiss()
        setTimeout(() => {
            dispatch(logout())
            localStorage.setItem("checkEventPopupByUser", 0);
            navigate(`${PATH_ROOT}/auth/login`)
        }, 1000);
    }

    const navigateProfileSetting = _ => {
        navigate(`${PATH_ROOT}/profile-user`)
        setAnchorEl(null)
    }

    const handleOpenDialogEnd = _ => {
        setAnchorEl(null)
        setOpenDialogCC({ id: 'dl-changepwd' })
    }

    const navigateManagerStorage = _ => {
        navigate(`${PATH_ROOT}/manager-storage`)
        setAnchorEl(null)
    }

    return (
        <Fragment>
            <TooltipCC title={t('profile.title')}>
                <Box className="header-profile-cc" sx={{ display: 'flex', alignItems: 'center' }} onClick={(e) => setAnchorEl(e.currentTarget)}>
                    <AvatarUser user={{ images: userAvatar, bgrColor: userBgrColor }} sx={{ width: theme.iconSize.medium, height: theme.iconSize.medium, fontSize: '20px' }} />
                    <MoreVertIcon sx={{ color: 'white', fontSize: theme.iconSize.small }} />
                </Box>
            </TooltipCC>
            <Menu
                id="profile-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{
                    'aria-labelledby': 'profile-more',
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItemCC key={'setting'} onClick={navigateProfileSetting}>
                    <IconSetting /> <Typography sx={{ marginLeft: theme.spacing(1), fontWeight: 500 }}>{t('profile.setting')}</Typography>
                </MenuItemCC>
                <MenuItemStorage key={'managerStorage'} onClick={navigateManagerStorage}>
                    <IconStorage /> <Typography sx={{ marginLeft: theme.spacing(1), fontWeight: 500 }}>{t('profile.storage')}</Typography>
                </MenuItemStorage>
                <Divider />
                <MenuItemCC key={'changepwd'} onClick={handleOpenDialogEnd}>
                    <IconChangePwd /> <Typography sx={{ marginLeft: theme.spacing(1), fontWeight: 500 }}>{t('profile.changepwd')}</Typography>
                </MenuItemCC>
                <MenuItemCC key={'logout'} onClick={handleLogout}>
                    <IconLogout /> <Typography sx={{ marginLeft: theme.spacing(1), fontWeight: 500 }}>{t('profile.logout')}</Typography>
                </MenuItemCC>
            </Menu>
        </Fragment>
    )
}

export default ProfileCC
